import { TimelineLite, TimelineMax, TweenLite } from "gsap/all";
import { INTRO_SPRITE_SRC, INTRO_SPITE_CONFIG } from "../const";
const obj = {
    x: 0,
};
class IntroSprite {
    constructor() {
        this.src = INTRO_SPRITE_SRC;
        this.step = 0;
        this.prevTime = null;
        this.image = document.createElement("img");
        this.image.src = INTRO_SPRITE_SRC;
        this.draw = this.draw.bind(this);
    }
    draw() {
        if (!this.isPlaying) {
            return;
        }
        window.requestAnimationFrame(this.draw);
        const { width, height } = INTRO_SPITE_CONFIG.size;
        const { count } = INTRO_SPITE_CONFIG;
        if (this.step > count) {
            return;
        }
        if (this.step === count - 2) {
            document.querySelector(".js-intro").classList.remove("is-light");
        }
        const now = Date.now();
        if (now - this.prevTime < 1000 / 10) {
            return;
        }
        this.prevTime = now;
        const { clientWidth, clientHeight } = this.container;
        const scale = clientWidth / width;
        const imgWidth = width * scale;
        const imgHeight = height * scale;
        const col = this.step % 10;
        const row = Math.floor(this.step / 10);
        this.ctx.clearRect(0, 0, clientWidth, clientHeight);
        this.ctx.drawImage(this.image, -imgWidth * col, -imgHeight * row - (imgHeight - clientHeight) * 0.5, imgWidth * 10, imgHeight * Math.ceil(count / 10));
        this.step += 1;
    }
    pause() {
        this.isPlaying = false;
        this.step = 0;
    }
    start() {
        this.isPlaying = true;
        this.prevTime = Date.now();
        this.draw();
    }
    init() {
        this.container = document.querySelector(".js-intro-scene-2");
        const { clientWidth, clientHeight } = this.container;
        this.canvas = document.createElement("canvas");
        this.ctx = this.canvas.getContext("2d");
        this.canvas.height = clientHeight;
        this.canvas.width = clientWidth;
        this.container.appendChild(this.canvas);
        this.draw();
    }
}
const introSprite = new IntroSprite();
export const preloaderAnimation = () => {
    // getTextAnimation(document.querySelector(".js-intro-scene-1"));
    return new TimelineLite({
        paused: true,
    })
        .fromTo(".js-intro-scene-2", 1, { autoAlpha: 0 }, { autoAlpha: 1 });
};
export default () => [
    // Second scene
    new TimelineLite({
        paused: true,
        onStart: () => {
            introSprite.init();
            introSprite.start();
            obj.x = 0;
        },
        onComplete: () => introSprite.start()
    })
        .fromTo('.js-intro-scene-2', 1, { autoAlpha: 0 }, { autoAlpha: 1 })
        .to(obj, 14, {
        x: INTRO_SPITE_CONFIG.count,
        onStart: () => {
            document.querySelector('.js-intro').classList.remove('is-light');
            document.body.classList.remove("is-second-intro-bg-shown");
        },
        onComplete: () => {
            introSprite.pause();
        },
    })
        .fromTo('.js-intro-scene-2', 0.6, { autoAlpha: 1 }, { autoAlpha: 0 }, '-=4'),
    // Last scene
    new TimelineMax({
        paused: true,
        // onStart: () => {
        //   document.querySelector('.js-intro').classList.remove('is-light');
        // },
    })
        .set('.js-intro-scene-3', { display: 'flex' })
        .fromTo('.js-intro-scene-3', 0.6, { autoAlpha: 0 }, { autoAlpha: 1, onComplete: () => TweenLite.set('.js-intro-scene-2', { display: 'none' }) })
        .staggerFromTo(".js-intro-scene-3 .js-animated-text", 0.3, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0 }, 0.2),
];
